/* Hook encargado de crear y modificar el Vehiculo

Autor: Benjamín León
Fecha: 2024-10-01
*/
import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'
import { DealShort } from '../components/DealEdit.tsx'

import { makeUrlDealEdit } from './connectionData.tsx'

interface ApiParams {
  deal: DealShort
  vehicle: string
  client: string
  organization: string
}
const useDealPoster = () => {
  const [errorPostDeal, setErrorPostDeal] = useState<Error | null>(null)
  const [loadingPost, setLoadingPost] = useState<boolean>(false)

  const postDeal = async (
    deal: DealShort,
    modificaSw: boolean,
    vehicleId: string,
    clientId: string,
    organizationId: string
  ) => {
    setLoadingPost(true)

    try {
      const apiUrl = makeUrlDealEdit(modificaSw)
      const apiParams: ApiParams = { deal: deal, vehicle: vehicleId, client: clientId, organization: organizationId }

      const res = await customPost<{ _id: string }>(apiUrl, apiParams)
      setErrorPostDeal(null)

      return res._id
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorPostDeal(err)
      } else {
        setErrorPostDeal(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoadingPost(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorPostDeal, loadingPost, postDeal }
}
export default useDealPoster
